import { createLabelSymbol } from "react-sgis/symbols/labelSymbols/labelSymbols";

export const tooltipSymbol = createLabelSymbol("tooltipSymbol");
export const textSymbol = createLabelSymbol("textSymbol");
